const scheduleStatuses = {
    PLANNED: 'Planned',
    SENT: 'Sent',
    DONE: 'Done',
  };
  
export default scheduleStatuses;
